const mutations = {
  udyamList(state, data) {
    state.udyamList = data;
  }
};
export default mutations;
